import { useUserProfileQuery } from "@graphql/api";
import ConcentricLoader from "@hudson/ui/components/Loader/ConcentricLoader";
import Session from "@lib/session";
import Layout from "./Layout";

export default function Locations() {
  const {
    data: profileData,
    loading: profileLoading,
    error,
  } = useUserProfileQuery({
    variables: { id: Session.getBooking().profiles.user },
  });

  if (error) {
    console.error(error);
    return null;
  }

  return profileLoading ? (
    <ConcentricLoader className="opacity-60 max-w-2xl mx-auto px-4 sm:py-10 sm:px-6 lg:px-8" />
  ) : (
    <div className="pb-8 min-h-[500px] mx-auto max-w-[600px] pt-8">
      <Layout locations={profileData?.userProfile?.locations || []} />
    </div>
  );
}
